export const reporting = {
  analyse: {
    title: 'Analyse des codes natures et catégories',
    filters: {
      groups: 'Groupes'
    },
    buttons: {
      validate: 'Afficher'
    },
    columns: {
      year: 'Année',
      january: 'Janvier',
      february: 'Février',
      march: 'Mars',
      april: 'Avril',
      may: 'Mai',
      june: 'Juin',
      july: 'Juillet',
      august: 'Août',
      september: 'Septembre',
      october: 'Octobre',
      november: 'Novembre',
      december: 'Décembre'
    }
  },

  analyseSolde: {
    title: 'Analyse des Soldes',
    filters: {
      groups: 'Groupes',
      company: 'Sociétés',
      year: 'Années'
    },
    buttons: {
      validate: 'Afficher'
    },
    column :{
      societe:"Sociétés",
      january: 'Janvier',
      february: 'Février',
      march: 'Mars',
      april: 'Avril',
      may: 'Mai',
      june: 'Juin',
      july: 'Juillet',
      august: 'Août',
      september: 'Septembre',
      october: 'Octobre',
      november: 'Novembre',
      december: 'Décembre'
    }
  }
};